var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container mb-5 gap-150 d-flex flex-column" },
    [
      _vm.currentJob.state === "failed" ? _c("error") : _vm._e(),
      _vm._v(" "),
      _vm.currentJob.state === "cancelled" ? _c("cancelled") : _vm._e(),
      _vm._v(" "),
      _vm.currentJob.state !== "failed" &&
      _vm.currentJob.state !== "cancelled" &&
      _vm.currentJob.state !== "unauthorized"
        ? _c(
            "div",
            { staticClass: "file-container", staticStyle: { opacity: "0.9" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "global-actions-container global-actions-container-top",
                },
                [
                  _c("div", { staticClass: "d-flex gap-10" }, [
                    _c(
                      "div",
                      {
                        staticClass: "file-action-btn gap-10",
                        class: { disabled: _vm.complete !== true },
                        on: { click: _vm.selectAll },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "currentColor",
                                d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5zm-9 12l-4-4l1.41-1.42L10 14.17l6.59-6.59L18 9",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("trans")("Select all")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "file-action-btn gap-10",
                        class: { disabled: _vm.complete !== true },
                        on: { click: _vm.deselectAll },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "currentColor",
                                d: "M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("trans")("Select none")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.currentJob.state === "not_found"
                ? _c("div", { staticClass: "p-3 bg-white" }, [
                    _c("div", { staticClass: "alert alert-danger pt-4" }, [
                      _c("p", [
                        _c("strong", [
                          _c("i", {
                            staticClass: "lh-inherit far fa-info-circle",
                          }),
                          _vm._v(
                            " " + _vm._s(_vm._f("trans")("Task not found"))
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("file-list-hints"),
              _vm._v(" "),
              _vm._l(_vm.currentJob.apiJob?.input, function (output) {
                return _vm.complete === false &&
                  _vm.currentJob.state !== "failed"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "file-item flex-column flex-md-row gap-10px",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "item d-inline-flex gap-10px" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox", disabled: "" },
                            }),
                            _vm._v(" "),
                            _vm._m(0, true),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "placeholder",
                                  style: {
                                    "min-width":
                                      _vm.getRandomInt(100, 300) + "px",
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "animated-background",
                                  }),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _c("file-list-outputs"),
              _vm._v(" "),
              _c("file-list-outputs-warning"),
              _vm._v(" "),
              _c("div", { staticClass: "global-actions-container" }, [
                _c("div", { staticClass: "d-flex gap-10" }, [
                  _c(
                    "div",
                    {
                      staticClass: "file-action-btn gap-10",
                      class: { disabled: _vm.complete !== true },
                      on: { click: _vm.selectAll },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "currentColor",
                              d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5zm-9 12l-4-4l1.41-1.42L10 14.17l6.59-6.59L18 9",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("trans")("Select all")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "file-action-btn gap-10",
                      class: { disabled: _vm.complete !== true },
                      on: { click: _vm.deselectAll },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "currentColor",
                              d: "M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("trans")("Select none")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.currentJob.apiJob?.warnings.length > 0 ? _c("warning") : _vm._e(),
      _vm._v(" "),
      _vm.currentJob.state === "unauthorized" ? _c("protected") : _vm._e(),
      _vm._v(" "),
      _vm.resultPage.isMobile === false
        ? _c("div", { staticClass: "feedback-full" }, [_c("feedback-full")], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.resultPage.isMobile === false && _vm.showFeatureRequest
        ? _c(
            "div",
            { staticClass: "feature-request" },
            [_c("feature-request-form")],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumb-small" }, [
      _c("div", [
        _c("div", { staticClass: "placeholder" }, [
          _c("div", { staticClass: "animated-background" }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }